<template lang="html">
  <div class="component-wrapper">
    <v-col class="text-center" cols="12">
      <p v-if="!successul_exam && nkh_course_type_id == 109">{{successful_message}}</p>
      <p v-if="nkh_course_type_id != 109">A gyakorlati oktatással kapcsolatos ügyintézés - a sikeres elméleti vizsgát követően - <a href="https://www.csigajogsi.hu/kapcsolat/" target="_blank" class="orange--text">ügyfélszolgálatainkon</a> keresztül lehetséges.</p>
      <p v-if="preg_archiv && teachers == '' && nkh_course_type_id == 109">Gyakorlati előjegyzése archiválva lett, kérjük érdeklődjön <a href="https://www.csigajogsi.hu/kapcsolat/" target="_blank">ügyfélszolgálatainkon</a>!</p>
    </v-col>
    <div v-if="successul_exam && nkh_course_type_id == 109 && teachers == '' && !preg_archiv" class="elojegyzes">
      <v-container>
      <v-card
        elevation="2"
        shaped
      >
      <v-card-title>Előjegyzés gyakorlati oktatásra</v-card-title>
      <v-container>
      <p v-if="prereg_id">A jelentkezés sikeres volt! Igény szerint az űrlapon módosítani tudja a megadott adatokat.</p>
      <v-form
        ref="prereg_form"
        v-model="valid"
      >
      <v-row>
          <v-col class="d-flex" cols="12" md="4">
          <v-select
            v-model="gyak_helyszin_value"
            :items="gyak_helyszin"
            label="Képzési helyszín"
            :rules="[rules.required]"
            outlined
            multiple
          ></v-select>
          </v-col>
          </v-row>
          <v-row>
          <v-col class="d-flex" cols="12" md="8">
            <v-textarea
            v-model="preg_comment"
            outlined
            label="Megjegyzés"
            hint="Kérjük írja le, hogy milyen időpontokban lenne alkalmas Önnek a vezetés."
            persistent-hint
            ></v-textarea>
          </v-col>
          </v-row>
          <v-row>
          <v-col cols="12" md="2">
            <v-btn
            :disabled="!valid"
            color="primary"
            rounded
            @click="savePreg"
            >
            Mentés
            <v-icon right dark>save</v-icon>
            </v-btn>
          </v-col>
      </v-row>
      </v-form>
      </v-container>
      </v-card>
      </v-container>
    </div>

    <v-container>
    <v-data-table
      v-if="teachers != ''"
      :headers="headers"
      :items="teachers"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item.lesson_price="{ item }">
        <v-btn
          v-if="item.lesson_price"
          color="primary"
          outlined
          rounded
          @click="gyakPayment(item.lesson_price, item.teacher_id)"

        >
          óradíj befizetés
          <v-icon
            right
            dark
          >
            credit_card
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-row v-if="contract_id && teachers != ''">
          <v-col class="text-center mt-2 mb-2" cols="12">
          <v-btn
            color="primary"
            to="/vizsgak"
            rounded
            outlined
          >
          Vizsgadíj befizetése
          </v-btn>
          </v-col>
      </v-row>
    </v-container>

        <v-dialog
          v-model="pay_dialog"
          width="500"
        >

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Óradíj befizetés
            </v-card-title>

            <v-container>
              <v-form
                ref="payment_form"
                v-model="payment_valid"
              >
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="lesson_number"
                    label="Óraszám"
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-select
                    v-model="payment_method"
                    :items="payment_methods"
                    label="Fizetési mód"
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                  <p v-if="payment_method == 2" class="red--text caption">(<b>Figyelem!</b> Átutalásos fizetési mód esetén a befizetett összeg jóváírása több napot is igénybe vehet!)</p>
                </v-col>
                </v-row>
                </v-form>
                <b>Díjbekérő összege:</b> {{sum_price}} Ft
            </v-container>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="pay_dialog = false, lesson_number = '', resetValidation()"
              >
                mégsem
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                text
                :disabled="!payment_valid || preloader"
                :loading="preloader"
                @click="gyakInvoice()"
              >
                küldés
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="pay_result_dialog"
          width="350"
        >

          <v-card>

            <v-container>
              <b>{{response_text}}</b>
              <br><br>
              A díjbekérőt megküldtük e-mailen!
            </v-container>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="pay_result_dialog = false"
              >
                bezár
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="public_url"
                color="green"
                text
                :href="public_url"
                target="_blank"
              >
                díjbekérő befizetése
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <v-snackbar
      v-model="snackbar"
    >
      {{ response_text }}
        <v-btn
          color="pink"
          text
          @click="snackbar = false"
        >
          bezár
        </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="error_snackbar"
      color = "error"
    >
      {{ response_text }}
        <v-btn
          color="white"
          text
          @click="error_snackbar = false"
        >
          bezár
        </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
  export default {
    data () {
      return {
        successul_exam: '',
        successful_message: '',
        exam_time: '',
        gyak_helyszin: [
          { text: 'Budaörs - Virágpiac', value: 'Virágpiac'},
          { text: 'Határ út (M3 metró állomás - Shopmark)', value: 'Határ út'},
          { text: 'Írottkő park (M3 bevezető)', value: 'Írottkő'},
          { text: 'Kőbánya-Kispest (KöKi Terminál)', value: 'Kőbánya-Kispest'},
          { text: 'Duna Pláza parkoló', value: 'Duna Pláza'},
          { text: 'Csepel (Szent Imre tér)', value: 'Csepel'},
          { text: 'Újpest - Berda József utca', value: 'Berda József'},
        ],
        gyak_helyszin_value: '',
        preg_comment: '',
        valid: true,
        rules: {
            required: value => value != '' || 'Kötelező mező!',
        },
        snackbar: false,
        response_text: '',
        prereg_id: '',
        teachers: [],
        headers: [
          { text: 'Oktató neve', value: 'name' },
          { text: 'Telefonszám', value: 'phone_number_mobile' },
          { text: 'Karton felvétel ideje', value: 'start_date' },
          { text: 'Karton leadás ideje', value: 'end_date' },
          { text: '', value: 'lesson_price' },
        ],
        preg_archiv: '',
        pay_dialog: false,
        lesson_number: '',
        lesson_price: '',
        sum_price: '',
        payment_methods: [
          { text: 'Bankkártya (online)', value: 17 },
          { text: 'Átutalás', value: 2 },
        ],
        payment_valid: true,
        payment_method: '',
        teacher_id: '',
        public_url: '',
        pay_result_dialog: false,
        error_snackbar: false,
      }
    },
    methods: {
      getPregDetails: async function() {
        this.preloader = true
        this.successful_message = 'Vizsgaadatok lekérdezése folyamatban...';
        this.prereg_id = null
        this.gyak_helyszin_value = null
        this.preg_comment = null
        await this.gettoken()
        this.$http.post('/gyakorlat/check_kresz_231007', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.successul_exam = response.data['successul_exam']
          this.successful_message = response.data['successful_message']
          this.exam_time = response.data['exam_time']
          this.prereg_id = response.data['adatok'][0]['id']
          this.gyak_helyszin_value = response.data['adatok'][0]['helyszin']
          this.preg_comment = response.data['adatok'][0]['megjegyzes_st']
          this.preg_archiv = response.data['adatok'][0]['archiv']
        }, (error) => {
          console.log(error.data);
        })
      },
      savePreg: async function() {
        await this.gettoken()
        this.$http.post('/gyakorlat/prereg_submit_20220112', {
          token: this.token,
          contract_id: this.contract_id,
          vizsga: this.exam_time,
          megjegyzes: this.preg_comment,
          helyszin: this.gyak_helyszin_value,
          preg_id: this.prereg_id
        }).then((response) => {
          this.snackbar = true
          this.response_text = response.data
          this.getPregDetails()
        }, (error) => {
          console.log(error.data);
        })
      },
      getTeacherList: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/gyakorlat/diakok_gyakorlat', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.teachers = response.data
          this.driving_school = response.data[0]['driving_school_id'];
        }, (error) => {
          console.log(error.data);
        })
      },
      validate () {
        this.$refs.prereg_form.validate()
        },
      resetValidation () {
        this.$refs.payment_form.resetValidation()
      },
      gyakPayment(price, teacher_id) {
        this.lesson_price = price;
        this.teacher_id = teacher_id;
        this.pay_dialog = true;
      },
      gyakInvoice: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/gyakorlat/create_gyak_invoice_230422', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          teacher_id: this.teacher_id,
          payment_method: this.payment_method,
          sum_price: this.sum_price,
          lesson_price: this.lesson_price,
          lesson_number: this.lesson_number,
          driving_school: this.driving_school,
        }).then((response) => {
          this.preloader = false
          this.pay_dialog = false
          this.lesson_number = ''
          this.resetValidation()
          this.response_text = response.data['message'];
          if (response.data['result'] == 'error') {
            this.error_snackbar = true
          } else {
            this.public_url = response.data['public_url'];
            this.pay_result_dialog = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
    },
    watch: {
      contract_id(value) {
        if (value) {
          this.getPregDetails()
          this.getTeacherList()
        }
      },
      lesson_number() {
        this.sum_price = this.lesson_number * this.lesson_price;
      }
    },
    mounted() {
      if (this.contract_id) {
        this.getPregDetails()
        this.getTeacherList()
      }
    },
    computed: {
    ...mapFields([
      'ids.customer_id',
      'ids.contract_id',
      'ids.nkh_course_type_id',
      'ids.driving_school',
      'ids.contract_driving_school',
      'user_datas.contracts',
      'ids.customer_name',
      'actions.preloader',
      'actions.message_dialog',
      'user_datas.studDetailsVaild'
    ]),
    },
  }
</script>

<style lang="css">
</style>
